<div id="head"></div>

<!-- The top box (owner 2026-10-15): the home's palettes box for this one palette, as the palettes page's expander
     shows it, in the page itself. -->
<h1 class="sr-only" *ngIf="product">{{ product.name }} Color Palette</h1>
<app-palette-expander *ngIf="product"
                      [inline]="true"
                      [product]="product"
                      [category]="category"
                      [palette]="palette"></app-palette-expander>

<!-- The palette detail sections: the named palette first, then the same
     channel / harmony / color-vision analysis as the theme pages, driven by
     the 10-color marketing palette. -->
<app-color-detail *ngIf="marketingHexes.length > 0" [boxes]="true"
                  [colors]="marketingHexes"
                  [namedPalette]="palette?.colors ?? []"
                  [relatedTheme]="relatedTheme"
                  [blogThemeKey]="relatedTheme?.product?.key"></app-color-detail>
